import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import GroupPhaseEdit from './../../elements/versions/version_group_phase';
import Loading from "../../elements/loading";

class VersionGroupPhaseEditForm extends Component {
	render() {
		const {version_groups_phases, projects} = this.props;
		return (
			(version_groups_phases.isFetching || projects.isFetching) ?
				<Loading/>:
				<GroupPhaseEdit
					{...this.props}
				/>
		);
	}

	componentWillMount() {
		const {year, id } = this.props.match.params;
		this.props.fetchVersionGroupPhaseComplete(year, id);
	}
}

export default BaseLayout(VersionGroupPhaseEditForm, {
	title:`Editar Proceso`,
	subnav: {
		icon: 'fa fa-calendar-check-o',
		name: 'Administración',
		actions: [
			{
				type: null,
				url: null,
				name: '',
				element: null
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/versions/version_groups_phases.jsx